import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { IUserDetails } from "../../../../models/user";
import { USER_MODULE_NAMESPACE } from "../../../../store/user/user-types.store";
import { namespace } from "vuex-class";
import * as _ from 'lodash';
import { UserTemplate } from '../../../../common/enums';

const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component
class TheNavigationComponent extends Vue {
  dtResources: { key?: string, icon?: string, path?: string, name?: string, img?:string, active?:string, index?:number, tooltip?:string }[]
  dtCurrentNav: { key?: string, icon?: string, path?: string, name?: string, active?: string } | null;
  @UserStore.Getter userInfo: IUserDetails;

  /**
   *
   */
  constructor() {
    super();
    this.dtResources = []//require('../../../../assets/json-resources/navigation-resource.json').resources;
    this.dtCurrentNav = {};
  }

  beforeMount()
  {
    if(this.userInfo.template === UserTemplate.default)
    {
      this.dtResources =  [
        {
          key: "HOME",
          icon: "icon-dashboard",
          img: "dashboard_blanc.png",
          active: "dashboard.png",
          path: "/home",
          name: "home",
          index: 0,
          tooltip:'Tableau de bord'
        },
        {
          key: "TICKET",
          icon: "icon-message",
          img: "chat_blanc.png",
          active: "chat.png",
          path: "/ticket",
          name: "ticket_list",
          index: 1,
          tooltip:'Mes tickets'
        },
        {
          key: "DOCUMENT",
          icon: "icon-document",
          img: "documents_blanc.png",
          active: "documents.png",
          path: "/document",
          name: "documents",
          index: 2,
          tooltip:'Mes documents'
        },
        {
          key: "BLOCK",
          icon: "icon-blocks",
          img: "immeubles_blanc.png",
          active: "immeubles.png",
          path: "/block",
          name: "block",
          index: 3,
          tooltip:'Mon parc'
        },
        {
          key: "SERVICE-BOOK",
          icon: "icon-service-book",
          img: "service_book_blanc.png",
          active: "service_book.png",
          path: "/service-book",
          name: "service_book",
          index: 4,
          tooltip:'Carnets d\'entretien'
        },
        {
          key: "CONTACT",
          icon: "icon-contact",
          img: "",
          active: "",
          path: "/contact",
          name: "contact",
          index: 5,
          tooltip:'Mes contacts'
        },
        {
          key: "AGENDA",
          icon: "book",
          path: "/agenda",
          img: "agenda_blanc.png",
          active: "agenda.png",
          name: "agenda",
          index: 6,
          tooltip:'Mon agenda'
        },
        {
          key: "SETTINGS",
          icon: "settings",
          path: "/settings",
          img: "settings.png",
          active: "settings.png",
          name: "settings_admin",
          index: 7,
          tooltip:'Paramètres'
        },
        {
          key: "PROFILE",
          icon: "profile",
          path: "/profile",
          name: "profile",
          index: 8,
          tooltip:'Mon profil'
        },
        {
          key: "RECEPTION",
          icon: "assignment_turned_in",
          img: "checking_blanc.png",
          active: "checking.png",
          path: "/reception",
          name: "reception_process",
          index: 9,
          tooltip:'Inspections',
        },
        {
          key: "VEHICLE-CHECK",
          icon: "assignment_turned_in",
          img: "vehicle_check_blanc.png",
          active: "vehicle_check.png",
          path: "/vehicle-check",
          name: "vehicle_check_process",
          index: 10,
          tooltip:'Contrôle de véhicules'
        },
        {
          key: "BM",
          icon: "assignment_turned_in",
          img: "site_monitoring.png",
          active: "site_monitoring.png",
          path: "/bm",
          name: "bm",
          index: 11,
          tooltip:'Suivi de chantier'
        }
      ]
    } else {
      this.dtResources =  [
        {
          key: "HOME",
          icon: "icon-dashboard",
          img: "dashboard_blanc.png",
          active: "dashboard.png",
          path: "/home",
          name: "home",
          index: 0,
          tooltip:'Tableau de bord'
        },
        {
          key: "SERVICE-BOOK",
          icon: "icon-service-book",
          img: "service_book_blanc.png",
          active: "service_book.png",
          path: "/service-book",
          name: "service_book",
          index: 1,
          tooltip:'Carnets d\'entretien'
        },
        {
          key: "DOCUMENT",
          icon: "icon-document",
          img: "documents_blanc.png",
          active: "documents.png",
          path: "/document",
          name: "documents",
          index: 2,
          tooltip:'Mes documents'
        }
      ]
    }
  }

  mounted() {
    this.coCurrentNav = this.dtResources.find(r => r.path === this.$route.path) || {};
  }


  get coRessourceDir(){
    return "../../../../assets/icon/navigation/"
  }

  get coCurrentNav() {
    return this.dtCurrentNav;
  }

  set coCurrentNav(value) {
    this.dtCurrentNav = value;
  }

  get agencyInfo() {
    return this.$store.getters.configuration.info
  }

  get availableResources() {
    const modulesStr = localStorage.getItem('navigations');
    if (modulesStr === null) return [];
    const modules = JSON.parse(modulesStr) as any[];
    let navigationModules = _.orderBy(modules.map(key => this.getNavigation(key)), ['index', 'desc']);
    navigationModules = navigationModules.filter(
                                              element => element
                                                  && element.hasOwnProperty('img')
                                                  && element.hasOwnProperty('active') )
    return navigationModules
  }
  /*checkVisible(nav) {
    if (nav.key === "SETTINGS_ADMIN" && this.userInfo.type === 'admin')
      return true
    return nav.key !== "SETTINGS_ADMIN"
  }*/

  coNavIcon(navItem: any){
    const navImages = require.context('../../../../assets/icon/navigation/',false,/\.(png|svg)$/)
    return this.coCurrentNav.key !== navItem.key ? navImages(`./${navItem.img}`) : navImages(`./${navItem.active}`)
  }

  isActived(nav: { key?: string, icon?: string, path?: string, name?: string }) {
    const rootPath: string = `/${nav.key.toLowerCase()}`;
    if (this.$route.path.indexOf(rootPath) === 0)
      return '__navtivation-item--active';
    return '__navtivation-item';
  }

  /* * getNavigation(key: string) {
    yield this.dtResources.find(nav => nav.name === key);
  } */

  getNavigation(key: string) {
    return this.dtResources.find(nav => nav.name === key);
  }

  getToolTip(key:string)
  {
    return this.dtResources.find(nav => nav.key === key).tooltip;
  }



  @Watch('$route.path')
  onRouteChange(newVal){
    if(newVal === '/profile'){
      this.coCurrentNav= {}
    }
  }
}

export default TheNavigationComponent;



// WEBPACK FOOTER //
// ./src/containers/app/components/the-navigation/index.ts